<template>
	<div class="facBIM">
		<Header v-show="show3"></Header>
		<!-- <BIM
      :bridgeObj="bridgeObj"
      :anjuanList="anjuanList"
      :zaixianList="zaixianList"
      v-show="bridgeObj.bridgeName == '新安江大桥'"
    ></BIM> -->
		<Supermap @pickDevice="gitxuanzhong" :tableData="tableData" :bridgeObj="bridgeObj"></Supermap>
		<!-- <Map
      :facList="[bridgeObj]"
      v-show="bridgeObj.bridgeName !== '新安江大桥'"
    ></Map> -->
		<el-collapse-transition>
			<div class="left" v-show="show3">
				<div class="l1" :style="{ display: display }">
					<left-top :qiaoLiangList="facList" :choosedEqType="choosedEqType" :bridgeObj="bridgeObj" @leftClick="leftClick" @showVideoList="showVideoList"></left-top>
				</div>
				<!-- <div class="l2" :style="{ display: display }"><left-bottom :bridgeObj="bridgeObj"></left-bottom></div> -->
				<!-- <img src="@/assets/image/menuLeft.png"
             alt=""
             class="menuImg"
             @click="show3 = !show3"
             :style="{ left: left }" /> -->
				<a href="javascript:;" class="reback" @click="reback()"></a>
			</div>
		</el-collapse-transition>
		<el-collapse-transition>
			<div class="left" style="color: #000"><img src="@/assets/image/menuLeft.png" alt="" class="small-menuImg" @click="show3 = !show3" /></div>
		</el-collapse-transition>
		<div class="right">
			<div class="r1">
				<!-- :eqPicNum="eqPicNum" -->
				<right-top
					:tableData="tableData"
					:typeList="typeList"
					:tableLoading="tableLoading"
					:echartData="echartData"
					@sheShiClick="sheShiClick"
					@gitxuanzhong="gitxuanzhong"
					ref="rightTop"
				></right-top>
			</div>
			<div :class="bridgeObj.bridgeName == '新安江大桥' ? 'r2' : 'rr2'"><right-bottom :bridgeObj="bridgeObj"></right-bottom></div>
		</div>
		<div class="bottom" v-if="zhexian">
			<Bottom ref="quxiantu"></Bottom>
			<img
				style="
          position: absolute;
          width: 30px;
          height: 30px;
          right: 15px;
          top: 5px;
        "
				@click="guanbi"
				src="../../assets/image/237a3f1c0c7b4f6db33832af0b68a50.png"
				alt="关闭"
				title="关闭传感器折线图"
			/>
		</div>
		<Footer></Footer>
		<!--视频列表-->
		<videoList ref="videolist"></videoList>
	</div>
</template>

<script>
import Header from '@/views/components/new/Header.vue';
import BIM from '@/views/components/BIM.vue';
import LeftBottom from '@/views/FacilityBim/components/leftBottom';
import LeftTop from '@/views/FacilityBim/components/leftTop';
import RightBottom from '@/views/FacilityBim/components/rightBottom';
import RightTop from '@/views/FacilityBim/components/rightTop';
import Map from '@/views/components/Maps.vue';
import Bottom from '@/views/FacilityBim/components/bottom';
import Footer from '@/views/components/new/Footer.vue';
import Supermap from '@/views//houTai/xunChaGuanLi/xunchajihua1.vue';
import videoList from '@/views/components/videoList.vue';
export default {
	data() {
		return {
			left: '4.2rem',
			display: 'block',
			bridgeObj: {},
			facList: [],
			eqPic: '',
			flagPic: false,
			show3: true,
			anjuanList: [],
			zaixianList: [],
			// 组件传递数据
			tableData: [],
			typeList: [],
			choosedEqType: {},
			echartData: [],
			tableLoading: false,
			// eqPicNum: '0'，
			zhexian: false
		};
	},
	computed: {},
	components: {
		RightTop,
		RightBottom,
		LeftTop,
		LeftBottom,
		Header,
		BIM,
		Map,
		Bottom,
		Footer,
		videoList,
		Supermap
	},

	async mounted() {
		console.log(this.$route.params.id);
		await this.getFac();
		// await this.getEqType();
		//
		await this.getEqType();
		// await this.echartsReq()
	},
	watch: {
		$route: {
			handler: function(val, oldVal) {
				this.bridgeObj = this.facList.find(i => {
					return i.bridgeUuid == this.$route.params.id;
				});
				if (this.bridgeObj.bridgeName !== '新安江大桥') {
					this.$refs.quxiantu.qingchudingshiqi;
					// clearInterval(this.$refs.quxiantu.dingshi)
					// this.$refs.quxiantu.dingshi=null;
					this.zhexian = false;
				}
			},
			deep: true
		}
	},
	methods: {
		// 大屏设备类型信息
		async getEqType() {
			const res = await this.$api.sendGet('/biBridge/getBridgeEquipmentTypeScreenList', { bridgeUuid: this.$route.params.id });
			if (res.data && res.data.length > 0) {
				this.typeList = res.data;
				this.choosedEqType = this.typeList[0];
				console.log('大屏设备类型信息', res.data);
				this.postChuan(res.data.equipmentTypeUuid);
				this.echartsReq();
			} else {
				this.typeList = [];
			}
		},
		// 根据设施uuid和设备类型uuid和设备名称获取传感器数据
		async postChuan(equipmentTypeUuid) {
			this.tableLoading = true;
			this.tableData = [];
			if (equipmentTypeUuid) {
				equipmentTypeUuid = equipmentTypeUuid;
			} else {
				equipmentTypeUuid = this.typeList[0].equipmentTypeUuid;
			}
			let data = {
				pageNum: 1,
				pageSize: 10,
				bridgeUuid: this.$route.params.id,
				equipmentTypeUuid: equipmentTypeUuid
			};
			const res = await this.$api.sendGet('/biBridge/getEquipmentByBiBridgeAndEquipmentTypeUuid', data);
			console.log(res);
			this.tableLoading = false;
			if (res.errcode == 0) {
				this.tableData = res.data;
			} else {
			}
			console.log('传感器数据', res);
		},
		// 根据设施uuid和设备类型uuid和设备名称获取传感器饼图数据
		async echartsReq(equipmentTypeUuid) {
			// /dataDhSensor/getSensorPieChartByBridgeUuidAndEquipmentTypeUuid
			let data = {
				bridgeUuid: this.$route.params.id,
				equipmentTypeUuid: equipmentTypeUuid ? equipmentTypeUuid : this.typeList[0].equipmentTypeUuid
			};
			const res = await this.$api.sendPost('/dataDhSensor/getSensorPieChartByBridgeUuidAndEquipmentTypeUuid', data);
			this.echartData = res.data.map(item => {
				return {
					value: item.dataValue,
					name: item.sensorName
				};
			});
			res.data;
			console.log('饼图数据', this.echartData);
		},
		//
		leftClick() {
			// console.log(123);
			this.getEqType();
			// this.echartsReq();
			// this.eqPicNum = '0'
		},
		sheShiClick(item) {
			console.log('sheShiClick', item);
			this.choosedEqType = this.typeList.find(i => i.equipmentTypeUuid == item);
			this.postChuan(item);
			// this.echartsReq(item);
			// this.eqPicNum = '0'
		},
		gitxuanzhong(equipmentName) {
			console.log(equipmentName);
			this.zhexian = true;
			setTimeout(i => {
				this.throttle(this.$refs.rightTop.setCurrent(equipmentName), 1000);
				this.throttle(this.$refs.quxiantu.getSensorByNameAndCreateTime(equipmentName), 1000);
			}, 100);
		},
		throttle(func, wait) {
			var previous = 0;
			return function() {
				let now = Date.now();
				let context = this;
				let args = arguments;
				if (now - previous > wait) {
					func.apply(context, args);
					previous = now;
				}
			};
		},
		//关闭
		guanbi() {
			this.$refs.quxiantu.qingchudingshiqi;
			// clearInterval(this.$refs.quxiantu.dingshi)
			// this.$refs.quxiantu.dingshi=null;
			this.zhexian = false;
		},
		//获取设施列表
		async getFac() {
			const res = await this.$api.sendGet('/biBridge/getBiBridgeScreenList');
			this.facList = res.data;
			this.bridgeObj = this.facList.find(i => {
				return i.bridgeUuid == this.$route.params.id;
			});
			
			console.log('aaaa', JSON.parse(JSON.stringify(this.bridgeObj)));
		},
		//获取在线人员列表
		async getzaixian() {
			let data = {
				pageNum: 1,
				pageSize: 0,
				accountUuid: this.$store.state.userintfo.accountUuid
			};
			const res = await this.$api.sendPost('/personalInformation/getPersonalInformation', data);
			this.zaixian = res.data.total;
			this.zaixianList = res.data.list;
		},
		//获取案件列表
		async getanjuan() {
			let data = {
				pageNum: 1,
				pageSize: 0
			};
			const res = await this.$api.sendPost('/report/getReport', data);
			this.anjuanList = res.data.list;
		},
		reback() {
			this.$router.back();
		},
		showVideoList(VideoUrl) {
			this.$refs.videolist.open(this.facList, VideoUrl);
		}
	}
};
</script>
<style lang="scss" scoped>
#Map {
	width: 100%;
	height: 100%;
	position: absolute;
}

.facBIM {
	width: 100vw;
	height: 100vh;
	position: absolute;
	z-index: 99;

	.left {
		// height: 897px;
		width: 420px;
		position: absolute;
		top: 138px;
		left: 10px;
		z-index: 999;
		// transition: width 2s;

		.l1 {
			height: 850px;
			// width: 100%;
			// border-radius: 4px;
			// margin-bottom: 20px;
			// background: rgba(3, 67, 79, 0.85);
			// box-shadow: 0px 8px 20px 0px rgba(0, 7, 26, 0.2);
			// backdrop-filter: blur(2px);
		}

		.l2 {
			height: 590px;
			width: 100%;
			background: rgba(3, 67, 79, 0.85);
			box-shadow: 0px 8px 20px 0px rgba(0, 7, 26, 0.2);
			border-radius: 4px;
			backdrop-filter: blur(2px);
		}

		.reback {
			position: absolute;
			left: 420px;
			width: 84px;
			height: 84px;
			top: -10px;
			background: url('~@/assets/image/reback.png') no-repeat;
			background-size: 100% 100%;
		}
	}

	.right {
		// height: 897px;
		width: 420px;
		position: absolute;
		top: 138px;
		right: 10px;
		z-index: 999;

		.r1 {
			height: 500px;
			margin-bottom: 20px;
			// width: 100%;
			// background: rgba(3, 67, 79, 0.85);
			// box-shadow: 0px 8px 20px 0px rgba(0, 7, 26, 0.2);
			// border-radius: 4px;
			// backdrop-filter: blur(2px);
			// margin-bottom: 20px;
		}

		.r2 {
			height: 326px;

			// width: 100%;
			// background: rgba(3, 67, 79, 0.85);
			// box-shadow: 0px 8px 20px 0px rgba(0, 7, 26, 0.2);
			// border-radius: 4px;
			// backdrop-filter: blur(2px);
		}

		.rr2 {
			// height: 850px;
			height: 326px;
		}
	}

	.bottom {
		width: calc(100% - 880px);
		height: 360px;
		position: absolute;
		bottom: 140px;
		left: 440px;
		// background: rgba(3, 67, 79, 0.85);
		// box-shadow: 0px 8px 20px 0px rgba(0, 7, 26, 0.2);
	}
}

.eqType {
	position: absolute;
	right: 460px;
	top: 138px;

	.list {
		width: 130px;
		height: 40px;
		margin-bottom: 30px;
		line-height: 40px;
		text-shadow: 0px 8px 20px rgba(0, 7, 26, 0.2);
		color: white;
		background: url('~@/assets/image/juxing.png') no-repeat;
		background-size: 100% 100%;
		cursor: pointer;

		img {
			position: absolute;
			right: -20px;
			margin-top: 10px;
		}
	}
}

.eqPic {
	position: absolute;
	// top: 138px;
	top: 200px;
	// left: 450px;
	right: 50px;
	width: 240px;
	height: 180px;
	background: #fff;
	// color: #000;
	// background: rgba(21, 55, 135, 0.9);
	box-shadow: 0px 8px 20px 0px rgba(0, 7, 26, 0.2);
	border-radius: 4px;
	backdrop-filter: blur(2px);
	box-sizing: border-box;
	padding: 15px;
	font-size: 18px;
	color: white;
	text-align: left;

	.san-jiao {
		font-size: 30px;
		position: absolute;
		top: -20px;
		right: 70px;
	}

	img {
		height: 20px;
		width: 20px;
		vertical-align: text-bottom;
	}

	::v-deep .el-image {
		width: 210px;
		height: 96px;
		margin-top: 21px;
	}
}

.menuImg {
	position: absolute;
	height: 80px;
	width: 18px;
	top: 400px;
	z-index: 99;
	cursor: pointer;
	// transition: all .2s;
}

.small-left {
	width: 60px;
	height: 120px;
	background: rgba(21, 55, 135, 0.9);
	box-shadow: 0px 8px 20px 0px rgba(0, 7, 26, 0.2);
	border-radius: 4px;
	backdrop-filter: blur(2px);
	display: flex;
	flex-direction: column;
	justify-content: space-around;
	position: relative;

	.titleIcon {
		width: 20px;
		height: 20px;
	}
}

.small-menuImg {
	position: absolute;
	// bottom: 0;
	left: 0px;
	top: 0px;
}
</style>
